import {
    GetActiveManagementRequestParams,
    IntervalDataQuery,
    IntervalReportSettings,
} from '@/hooks/useApi/useActiveManagementApi/types'

export type IntervalDataQuerySettings = Partial<
    Pick<
        IntervalReportSettings,
        'dataGrouping' | 'type' | 'timeInterval' | 'timezone' | 'dataType'
    >
>

export const mapIntervalDataQueryFromGetParams = (
    params: Partial<GetActiveManagementRequestParams>,
    settings?: IntervalDataQuerySettings
): IntervalDataQuery => {
    function splitIds(val?: string): number[] {
        return val ? val.split(',').filter(Boolean).map(Number) : []
    }

    const nodeIds = splitIds(params['nodeIds[]'])
    const tagIds = splitIds(params['tagIds[]'])
    const facilityIds = splitIds(params['facilityIds[]'])
    const usnAccountIds = splitIds(params['usnAccountIds[]'])
    const meterIds = splitIds(params['meterIds[]'])
    const subMeterIds = splitIds(params['subMeterIds[]'])

    const query: IntervalDataQuery = {
        type: params.type ?? 'utilityData',
        startDate: params.startDate ?? '',
        endDate: params.endDate ?? '',
        nodeIds,
        tagIds,
        facilityIds,
        usnAccountIds,
        meterIds,
        subMeterIds,
        timeInterval: settings?.timeInterval,
        timezone: settings?.timezone,
        dataGrouping: settings?.dataGrouping,
        dataType: settings?.dataType,
        sortOrder: params.sortOrder,
    }
    return query
}
